import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const NaturalHistoryMuseum = {
  id: '125',
  name: "Natural History Museum",
  width: 4,
  height: 3,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Natural_History_Museum',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Natural_History_Museum',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.LIGHT_INFANTRY_CRITICAL_HIT_CHANCE_MOD,
      EffectAmount.asCallbackWithLevel((level) => {
        if (level <= 2) return 7;
        if (level <= 5) return 10;
        if (level <= 8) return 15;
        if (level <= 12) return 20;
        if (level <= 15) return 26;
        if (level <= 18) return 31;
        if (level <= 22) return 36;
        if (level <= 25) return 42;
        if (level <= 28) return 47;
        if (level <= 32) return 52;
        if (level <= 35) return 58;
        if (level <= 38) return 63;
        if (level <= 42) return 68;
        if (level <= 45) return 74;
        if (level <= 48) return 79;
        if (level <= 52) return 84;
        if (level <= 55) return 90;
        if (level <= 58) return 95;
        return 100;
      }),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asPerLevel([
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
        2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
        3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
        4,
      ]),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          84,90,96,102,108,114,120,126,132,138,144,150,156,162,168,174,180,186,192,198,204,210,216,222,228,234,240,246,252,258,264,270,276,282,288,294,300,306,312,318,324,330,336,342,348,354,360,366,372,378,384,390,396,402,408,414,420,426,432,438
        ],
        bronzeAge: [
          93,100,107,114,121,128,135,142,149,156,163,170,177,184,191,198,205,212,219,226,233,240,247,254,261,268,275,282,289,296,303,310,317,324,331,338,345,352,359,366,373,380,387,394,401,408,415,422,429,436,443,450,457,464,471,478,485,492,499,506
        ],
        minoanEra: [
          102,110,118,126,134,142,150,158,166,174,182,190,198,206,214,222,230,238,246,254,262,270,278,286,294,302,310,318,326,334,342,350,358,366,374,382,390,398,406,414,422,430,438,446,454,462,470,478,486,494,502,510,518,526,534,542,550,558,566,574
        ],
        classicGreece: [
          111,120,129,138,147,156,165,174,183,192,201,210,219,228,237,246,255,264,273,282,291,300,309,318,327,336,345,354,363,372,381,390,399,408,417,426,435,444,453,462,471,480,489,498,507,516,525,534,543,552,561,570,579,588,597,606,615,624,633,642
        ],
        earlyRome: [
          120,130,140,150,160,170,180,190,200,210,220,230,240,250,260,270,280,290,300,310,320,330,340,350,360,370,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620,630,640,650,660,670,680,690,700,710
        ],
        romanEmpire: [
          129,140,151,162,173,184,195,206,217,228,239,250,261,272,283,294,305,316,327,338,349,360,371,382,393,404,415,426,437,448,459,470,481,492,503,514,525,536,547,558,569,580,591,602,613,624,635,646,657,668,679,690,701,712,723,734,745,756,767,778
        ],
        byzantineEra: [
          138,150,162,174,186,198,210,222,234,246,258,270,282,294,306,318,330,342,354,366,378,390,402,414,426,438,450,462,474,486,498,510,522,534,546,558,570,582,594,606,618,630,642,654,666,678,690,702,714,726,738,750,762,774,786,798,810,822,834,846
        ],
        ageOfTheFranks: [
          147,160,173,186,199,212,225,238,251,264,277,290,303,316,329,342,355,368,381,394,407,420,433,446,459,472,485,498,511,524,537,550,563,576,589,602,615,628,641,654,667,680,693,706,719,732,745,758,771,784,797,810,823,836,849,862,875,888,901,914
        ],
        feudalAge: [
          156,170,184,198,212,226,240,254,268,282,296,310,324,338,352,366,380,394,408,422,436,450,464,478,492,506,520,534,548,562,576,590,604,618,632,646,660,674,688,702,716,730,744,758,772,786,800,814,828,842,856,870,884,898,912,926,940,954,968,982
        ],
        iberianEra: [
          165,180,195,210,225,240,255,270,285,300,315,330,345,360,375,390,405,420,435,450,465,480,495,510,525,540,555,570,585,600,615,630,645,660,675,690,705,720,735,750,765,780,795,810,825,840,855,870,885,900,915,930,945,960,975,990,1005,1020,1035,1050
        ],
        kingdomOfSicily: [
          174,190,206,222,238,254,270,286,302,318,334,350,366,382,398,414,430,446,462,478,494,510,526,542,558,574,590,606,622,638,654,670,686,702,718,734,750,766,782,798,814,830,846,862,878,894,910,926,942,958,974,990,1006,1022,1038,1054,1070,1086,1102,1118
        ],
        highMiddleAges: [
          183,200,217,234,251,268,285,302,319,336,353,370,387,404,421,438,455,472,489,506,523,540,557,574,591,608,625,642,659,676,693,710,727,744,761,778,795,812,829,846,863,880,897,914,931,948,965,982,999,1016,1033,1050,1067,1084,1101,1118,1135,1152,1169,1186
        ],
        earlyGothicEra: [
          192,210,228,246,264,282,300,318,336,354,372,390,408,426,444,462,480,498,516,534,552,570,588,606,624,642,660,678,696,714,732,750,768,786,804,822,840,858,876,894,912,930,948,966,984,1002,1020,1038,1056,1074,1092,1110,1128,1146,1164,1182,1200,1218,1236,1254
        ],
        lateGothicEra: [
          201,220,239,258,277,296,315,334,353,372,391,410,429,448,467,486,505,524,543,562,581,600,619,638,657,676,695,714,733,752,771,790,809,828,847,866,885,904,923,942,961,980,999,1018,1037,1056,1075,1094,1113,1132,1151,1170,1189,1208,1227,1246,1265,1284,1303,1322
        ]
      }).withOutput(ProductionOutputType.CURRENT_ERA_TERTIARY_GOODS),
    ),
  ]),
};

export default NaturalHistoryMuseum;
